import React, { useRef, useState, useEffect } from "react";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const CountryDropdown = ({ textColor, title, onSelect, required }) => {
  const buttonRef = useRef(null);
  const [buttonWidth, setButtonWidth] = useState(0);
  const { t, i18n } = useTranslation();
  const [selectedItem, setSelectedItem] = useState(
    t("calculateShippingSection.selectArea")
  );

  const [countries, setCountries] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, []);

  const direction = useLanguageDirection();

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        // https://restcountries.com/v3.1/all
        const response = await fetch("/countriesAPI.json");

        const data = await response.json();
        // console.log(data)
        const language = localStorage.getItem("language");
        const formattedCountries = data.map((country) => ({
          id: country.cca2,
          name:
            language === "ar"
              ? country.translations?.ara?.common
              : country.name.common,
          englishName: country.name.common,
          flag: country.flags.svg,
          phoneCode:
            country.idd?.root +
            (country.idd?.suffixes ? country.idd.suffixes[0] : ""),
        }));
        setCountries(
          formattedCountries.sort((a, b) => a.name.localeCompare(b.name))
        );
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, [i18n.language]);

  useEffect(() => {
    setSelectedItem(t("calculateShippingSection.selectArea"));
  }, [i18n.language]);

  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Menu as="div" className="relative inline-block w-full" dir={direction}>
      <div>
        <h4 className="text-lg text-gray-800 ">{title}</h4>
        <Menu.Button
          className={`flex md:text-base text-sm items-center justify-between rounded-md bg-white border border-gray-300 p-3 w-full  text-gray-700`}
          dir={direction}
        >
          <span className="text-gray-400 md:mx-1">{selectedItem}</span>
          <ChevronDownIcon className="w-6 h-6 text-black" />
        </Menu.Button>
      </div>

      <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-40 mt-1 overflow-y-auto bg-white border border-gray-300 rounded-md shadow-lg focus:outline-none h-[60vh] w-11/12 lg:w-[50%]">
        <div className="sticky top-0 p-2 bg-white border-b">
          <input
            type="text"
            placeholder={t("search")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-3 py-2 text-gray-700 bg-white border rounded-md"
          />
        </div>
        {filteredCountries.map((country) => (
          <Menu.Item key={country.id}>
            {({ active }) => (
              <button
                onClick={() => {
                  setSelectedItem(country.name);
                  onSelect({
                    name: country.englishName,
                    phoneCode: country.phoneCode,
                  });
                }}
                className={`flex items-center px-4 py-2 text-sm text-start w-full ${
                  active ? "bg-gray-100 text-gray-900" : "text-gray-500"
                }`}
              >
                <img
                  src={country.flag}
                  alt={country.name}
                  className="h-auto w-7 me-2"
                />
                {country.name}
              </button>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
};

export default CountryDropdown;
